import _ from 'lodash';
import { getShipments } from '../../../api/orders/shipment/shipment';
import { Shipment } from '../../../api/orders/shipment/shipmentTypes';
import { toDateApiFormat } from '../../../services/dateUtils';

export function formatCarrier(shipment: Shipment): string {
  const deliveryTypes = _.compact(shipment.deliveryTypes);

  return _.isEmpty(deliveryTypes)
    ? shipment.carrier
    : `${shipment.carrier} (${deliveryTypes.join(', ')})`;
}

export async function loadShipments(date: Date, signal?: AbortSignal): Promise<Shipment[]> {
  return getShipments(toDateApiFormat(date), signal);
}
